import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestDeleteCategory } from "./deleteCategory.request";

const useDeleteCategory = (
  options?: MutationOptions<Category, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteCategory,
    ...options
  });
};

export default useDeleteCategory;
